import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M2.5 16.667v-4.644l4.134-4.134 2.356 2.535.59-.59-2.924-3.146L2.5 10.844V3.333c0-.459.374-.833.833-.833h13.333c.073 0 .138.024.205.042l.637-.637c-.248-.147-.534-.238-.842-.238H3.333c-.917 0-1.667.75-1.667 1.667v13.333c0 .308.09.594.238.842l.637-.637c-.018-.067-.042-.133-.042-.205z',
    'M13.75 5c.193 0 .374.048.537.126l.612-.612a2.069 2.069 0 0 0-1.149-.347c-1.151 0-2.083.933-2.083 2.083 0 .425.129.82.347 1.149l.612-.612c-.079-.163-.126-.344-.126-.537 0-.689.561-1.25 1.25-1.25zM19.411 2.36L2.36 19.411l.589.589 1.665-1.665 12.053-.002c.241 0 .469-.054.676-.147.582-.261.991-.844.991-1.519V4.616l1.667-1.667-.589-.589zM17.5 16.667c0 .448-.357.809-.801.827-.011 0-.021.007-.032.007H5.449l5.245-5.245 1.962 2.111 2.322-2.322 2.522 2.713v1.909zm0-3.133l-2.5-2.69-2.323 2.323-1.395-1.501 6.217-6.217v8.085z',
  ],
  height: 20,
  width: 20,
});
